import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Careers from "../pages/careers/page";
import Partnership from "../pages/partnership/page";
import Terms from "../pages/terms/page";
import Privacy from "../pages/privacy/page";
import Cookies from "../pages/cookies/page";
import Blog from "../pages/blog/page";
import BlogPost from "../pages/blog/post/page";
import Diagnosis from "../pages/diagnosis/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/diagnosis", element: <Diagnosis /> },
  { path: "/blog", element: <Blog /> },
  { path: "/blog/:slug", element: <BlogPost /> },
  { path: "/careers", element: <Careers /> },
  { path: "/partnership", element: <Partnership /> },
  { path: "/terms", element: <Terms /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/cookies", element: <Cookies /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
